<div #container class="canvas-wrapper">  
  <canvas class="d-flex" width="{{canvasWidth}}" height="{{canvasHeight}}" #rendererCanvas id="{{decoration.longId}}"></canvas>
</div>